import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-send",
  "use": "icon-send-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-send\"><path d=\"M822.464 388.48a44.288 44.288 0 0 0-64 0L555.776 591.104V146.048a46.208 46.208 0 0 0-45.952-46.528 46.208 46.208 0 0 0-45.952 46.528v444.992L271.616 396.288a45.056 45.056 0 0 0-64.32 0.64 46.464 46.464 0 0 0 0 64.448l265.792 268.864c9.216 9.28 9.216 9.28 18.048 9.28h37.376c9.216 0 9.216-9.28 18.368-9.28l265.472-268.8a49.664 49.664 0 0 0 13.888-68.352 29.76 29.76 0 0 0-3.776-4.544z\" fill=\"#01B075\" p-id=\"3102\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol